import styled from 'styled-components';
import { spacing } from 'ui/theme';

export const ButtonContainer = styled.div`
  margin-top: ${spacing.double};
`;
